import {
    getTotalIncomeRank,
    getFhlIncomeRank
} from '@/api/member'

export default {
    state: {},
    mutations: {},
    actions: {
        handleGetTotalIncomeRank ({ commit }, data) {
            return new Promise((resolve, reject) => {
                getTotalIncomeRank(data)
                .then(res => {
                  resolve(res)
                })
                .catch(err => {
                  reject(err)
                })
            })
        },
        handleGetFhlIncomeRank ({ commit }, data) {
            return new Promise((resolve, reject) => {
                getFhlIncomeRank(data)
                .then(res => {
                  resolve(res)
                })
                .catch(err => {
                  reject(err)
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/module/member.js